module.exports = __webpack_public_path__ + "static/media/group-image.e2f922c0.png";